<form #container class="k-form k-form-horizontal" style="max-width: 700px;width: 700px;" [formGroup]="formGroup">
  <kendo-tabstrip>
    <kendo-tabstrip-tab title="{{ customMsgService.translate('toolTypeDados') }}" [selected]="true">
      <ng-template kendoTabContent>

        <fieldset class="k-form-fieldset">
          <kendo-formfield orientation="horizontal">
            <label class="k-label">
              <img [src]="imgURL" style="object-fit: contain;" width="100px" height="100px" shape="square" />
            </label>
            <kendo-fileselect (select)="selectAvatar($event)" [showFileList]="false" formControlName="imagem"
              [multiple]="false" [restrictions]="fileRestrictions">
              <kendo-fileselect-messages select="Select image" dropFilesHere="Drop  image here">
              </kendo-fileselect-messages>
            </kendo-fileselect>
            <kendo-formerror> Error: File extension not allowed. </kendo-formerror>
          </kendo-formfield>
          <h5>{{ customMsgService.translate('tooltypes') }}</h5>
          <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="idTamanho" [text]="customMsgService.translate('size')"> </kendo-label>
            <kendo-dropdownlist formControlName="idTamanho" textField="description" valueField="id"
              [defaultItem]="placeHolder" [data]="listItemsTamanhos" #idTamanho required>
            </kendo-dropdownlist>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
              customMsgService.translate('jobTitle') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>

          </kendo-formfield>

          <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="pt" [text]="customMsgService.translate('pt')"> </kendo-label>
            <kendo-textbox [maxlength]="maxlength" (inputBlur)="inputBlur()" formControlName="pt" [clearButton]="true"
              #pt required> </kendo-textbox>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
              customMsgService.translate('pt') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>

          </kendo-formfield>

          <kendo-formfield orientation="horizontal">
            <kendo-label [for]="en" [text]="customMsgService.translate('en')"> </kendo-label>
            <kendo-textbox [maxlength]="maxlength" formControlName="en" [clearButton]="true" #en required>
            </kendo-textbox>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
              customMsgService.translate('en') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>

          </kendo-formfield>



          <kendo-formfield orientation="horizontal">
            <kendo-label [for]="fr" [text]="customMsgService.translate('fr')"> </kendo-label>
            <kendo-textbox [maxlength]="maxlength" formControlName="fr" [clearButton]="true" #fr required>
            </kendo-textbox>
            <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
              customMsgService.translate('fr') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>

          </kendo-formfield>

          <kendo-formfield orientation="horizontal">
            <kendo-label class="k-label" [for]="obs" [text]="customMsgService.translate('obs')"> </kendo-label>
            <kendo-textarea formControlName="obs" #obs> </kendo-textarea>

          </kendo-formfield>



        </fieldset>

      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [title]="customMsgService.translate('listaDeAvarias')" [selected]="false">
      <ng-template kendoTabContent>


        <kendo-grid #grid [data]="avariasTipoFerramenta" [sortable]="true" class="k-grid-avarias"
          (edit)="editHandler($event)" (drop)="onDrop($event, grid)" (dragover)="onDragOver($event, grid)"
          (dragstart)="onDragStart($event, grid)" (add)="addHandler()" [selectable]="true"
          (remove)="removeHandler($event)">
          <!-- (edit)="editHandler($event)"
                
                (add)="addHandler()" 
                [navigable]="true" -->
          <ng-template kendoGridToolbarTemplate>
            <kendo-grid-spacer></kendo-grid-spacer>
            <!-- <button kendoButton icon="add" themeColor="primary">
               
                    </button> -->
            <button kendoGridAddCommand icon="add" [title]="customMsgService.translate('btnAdicionar')"
              themeColor="primary"></button>
            <!-- (cellClick)="cellClickHandler($event)"
                (cellClose)="cellCloseHandler($event)"
                (cancel)="cancelHandler($event)"
                (save)="saveHandler($event)"
                (remove)="removeHandler($event)"
                (add)="addHandler($event)" -->

            <!-- <button
                    kendoButton
                    [disabled]="!editService.hasChanges()"
                    (click)="saveChanges(grid)"
                  >
                    Save Changes
                  </button>
                  <button
                    kendoButton
                    [disabled]="!editService.hasChanges()"
                    (click)="cancelChanges(grid)"
                  >
                    Cancel Changes
                  </button> -->
          </ng-template>
          <kendo-grid-column field="codigo" [title]="customMsgService.translate('codigo')"></kendo-grid-column>
          <kendo-grid-column field="pt" title="PT"></kendo-grid-column>
          <kendo-grid-column field="en" title="EN"></kendo-grid-column>
          <kendo-grid-column field="fr" title="FR"></kendo-grid-column>
          <kendo-grid-column field="observacao" [title]="customMsgService.translate('obs')"></kendo-grid-column>
          <kendo-grid-command-column title="" [width]="100">
            <ng-template kendoGridCellTemplate let-isNew="isNew">
              <button kendoGridEditCommand icon="edit" [title]="customMsgService.translate('btnEditar')"
                [primary]="true"></button>
              <button kendoGridRemoveCommand icon="trash" [title]="customMsgService.translate('btnEliminar')"
                themeColor="error"></button>
            </ng-template>
          </kendo-grid-command-column>
        </kendo-grid>

      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
  <hr />
  <div class="k-form-buttons">
    <button kendoButton (click)="cancelChanges()">
      {{ customMsgService.translate('cancel') }}
    </button>
    <button kendoButton [primary]="true" [disabled]="formGroup.invalid || formGroup.pristine" (click)="saveChanges()">
      {{ customMsgService.translate('saveChanges') }}
    </button>
  </div>
</form>

<app-avaria-type-form [model]="editDataItem" [isNew]="isNew" (save)="saveHandler($event)" (cancel)="cancelHandler()">
</app-avaria-type-form>